import KendoWindow from './KendoWindow'
import KendoWindowInstaller from './kendo-window-installer'

export { KendoWindow, KendoWindow as Window, KendoWindowInstaller, KendoWindowInstaller as WindowInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/index.js